export const locales = [
  {
    locale: "en",
    default: true,
  },
  {
    locale: "de",
  },
  {
    locale: "fr",
  },
  {
    locale: "es",
  },
] as const

export const defaultLocale = "en"
